import { httpClientFormsApi } from './http-client';

export const getDangerProducts = async (page, filters) => {
  try {
    const response = await httpClientFormsApi.get('api/getproducts', {
      params: { ...filters, page, show: 9 },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching danger products:', error);
    throw error;
  }
};

export const getDangerProductDetails = async (id) => {
  try {
    const response = await httpClientFormsApi.get(`api/getproductdetail/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching danger products:', error);
    throw error;
  }
};

const extractFields = (items) =>
  items.map(({ id: value, title_geo: label }) => ({ value, label }));

export const getFilterOptions = async () => {
  try {
    const { data } = await httpClientFormsApi.get('api/getFilters');

    if (!data) {
      throw new Error('No data received from the API');
    }

    const filters = {
      categories: extractFields(data.categories || []),
      countries: extractFields(data.countries || []),
      risks: extractFields(data.risks || []),
      danger_levels: extractFields(data.danger_levels || []),
    };

    // console.log('Fetched Filters:', filters);

    return filters;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('API Error Response:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
      });
    } else if (error.request) {
      // The request was made but no response was received
      console.error('No response received:', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error setting up request:', error.message);
    }
    throw error;
  }
};

// export const getFilters = async () => {
//   try {
//     const response = await httpClientFormsApi.get('api/getFilters');

//     response.data.categories = response.data.categories.map(
//       (category) => category.title_geo
//     );

//     response.data.countries = response.data.countries.map(
//       (country) => country.title_geo
//     );

//     response.data.risks = response.data.risks.map((risk) => risk.title_geo);

//     response.data.danger_levels = response.data.danger_levels.map(
//       (dangerLevel) => dangerLevel.title_geo
//     );

//     return response.data;
//   } catch (error) {
//     console.error('Error fetching filters:', error);
//     throw error;
//   }
// };

export const getCategoryFilter = async (id) => {
  if (!id || isNaN(id)) {
    console.error('Invalid ID detected:', id);
    return;
  }
  try {
    const response = await httpClientFormsApi.get(
      `api/getCategoryFilter/${id}`
    );
    return response.data.map((group) => {
      return {
        label: group.category.title_geo,
        options: extractFields(group.subcategories),
      };
    });
  } catch (error) {
    if (error.response) {
      console.error('API Response Error:', error.response.data);
    } else {
      console.error('Error fetching category filter:', error.message);
    }
    throw error;
  }
  // catch (error) {
  //   console.error('Error fetching category filter:', error);
  //   throw error;
  // }
};
